import { useEffect, useRef, useState } from 'react';

export const FAQ = ({
  faqNo,
  faqQstn,
  faqAnswer,
  className,
  className1,
  selected,
  setSelected,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    setIsOpen(selected === faqNo);
  }, [selected]);

  return (
    <div
      className={`${className} mx-auto w-[300px] cursor-pointer items-center justify-center p-[32px] transition-all duration-200 ease-out xs:w-[350px] sm:w-[550px] md:w-[650px] lg:max-w-[768px] ${
        isOpen ? `${className1} ` : ''
      }`}
      onClick={() => setSelected(!isOpen ? faqNo : null)}
    >
      <dl className='space-y-[8px]'>
        <dt className='text-lg'>
          <button
            type='button'
            className={`flex w-full items-start text-left text-white`}
            aria-controls={`faq-${faqNo}`}
            aria-expanded={isOpen}
          >
            <span className='flex items-center'>
              {isOpen ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='25'
                  height='24'
                  viewBox='0 0 25 24'
                  fill='none'
                  className='transition-transform duration-200 ease-out'
                >
                  <path
                    d='M8.42578 12H16.4258M22.4258 12C22.4258 17.5228 17.9486 22 12.4258 22C6.90293 22 2.42578 17.5228 2.42578 12C2.42578 6.47715 6.90293 2 12.4258 2C17.9486 2 22.4258 6.47715 22.4258 12Z'
                    stroke='#98A2B3'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='25'
                  height='24'
                  viewBox='0 0 25 24'
                  fill='none'
                  className='rotate-0 transition-transform duration-200 ease-out hover:rotate-90'
                >
                  <path
                    d='M12.4258 8V16M8.42578 12H16.4258M22.4258 12C22.4258 17.5228 17.9486 22 12.4258 22C6.90293 22 2.42578 17.5228 2.42578 12C2.42578 6.47715 6.90293 2 12.4258 2C17.9486 2 22.4258 6.47715 22.4258 12Z'
                    stroke='#98A2B3'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              )}
            </span>
            <h3 className='pl-[24px] font-heading text-base font-medium leading-normal text-white transition-all duration-200 ease-out hover:text-gray-300 sm:text-lg md:text-xl lg:text-2xl xl:text-2xl'>
              {faqQstn}
            </h3>
          </button>
        </dt>
        <dd
          className={`overflow-hidden transition-all duration-200 ease-out`}
          id={`faq-${faqNo}`}
          ref={contentRef}
          style={{
            maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0',
            opacity: isOpen ? 1 : 0,
            transform: isOpen ? 'translateY(0)' : 'translateY(-8px)',
          }}
        >
          <p className='text-gray-white-2 pl-[48px] pt-[8px] font-heading text-sm font-normal leading-relaxed sm:text-base md:text-base lg:text-base xl:text-lg'>
            {faqAnswer}
          </p>
        </dd>
      </dl>
    </div>
  );
};
